import { ECalculateResultModalActionType } from '../../actions/calculateResultModal';
import { ICalculateResultModalState } from '../../types/calculateResultModal';
import { TReduxActions } from '../../types/redux';

const defaultState: ICalculateResultModalState = {
  isOpen: false,
};

export function calculateResultModalReducer(
  state: ICalculateResultModalState = defaultState,
  action: TReduxActions,
): ICalculateResultModalState {
  switch (action.type) {
    case ECalculateResultModalActionType.ModalOpened:
      return {
        ...state,
        isOpen: true,
      };
    case ECalculateResultModalActionType.ModalClosed:
      return {
        ...state,
        isOpen: false,
      };
  }

  return state;
}
